export const ProductRemoteProviders=Object.freeze({
  SHAZDEH:   "شازده کوچولو",
  BASALAM:  "باسلام",
});